import React from 'react';
import Button from 'carbon-react/lib/components/button';
import PopoverContainer, { RenderOpenProps } from 'carbon-react/lib/components/popover-container';
import Badge from 'carbon-react/lib/components/badge';
import Box from 'carbon-react/lib/components/box';

import { FormattedMessage, useIntl } from '@futrli/localisation';

import * as styles from './filter-header.scss';

interface FiltersButtonProps {
  activeCount: number;
  onManageFilters: () => void;
  onClearAll: () => void;
}

export const FiltersButton = ({ activeCount, onManageFilters, onClearAll }: FiltersButtonProps) => {
  const intl = useIntl();

  if (activeCount === 0) {
    return (
      <Button
        buttonType="secondary"
        size="medium"
        onClick={onManageFilters}
        aria-label={intl.formatMessage({ id: 'predict.filters', defaultMessage: 'Filters' })}
        mt="29px"
      >
        <FormattedMessage id="predict.filters" defaultMessage="Filters" />
      </Button>
    );
  }

  return (
    <PopoverContainer
      p={0}
      renderOpenComponent={({
        id,
        ref,
        onClick,
        'data-element': dataElement,
        'aria-label': ariaLabel,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHasPopup
      }: RenderOpenProps) => (
        <Box mt="29px" className={styles.popoverTrigger}>
          <Badge counter={activeCount}>
            <Button
              buttonType="secondary"
              size="medium"
              onClick={onClick}
              data-element={dataElement}
              aria-label={ariaLabel || intl.formatMessage({ id: 'predict.filters', defaultMessage: 'Filters' })}
              aria-haspopup={ariaHasPopup}
              aria-expanded={ariaExpanded}
              ref={ref}
              id={id}
            >
              <FormattedMessage id="predict.filters" defaultMessage="Filters" />
            </Button>
          </Badge>
        </Box>
      )}
      renderCloseComponent={() => <></>}
    >
      <div className={styles.popoverMenu} id="create-filter-button-popover">
        <div
          className={styles.popoverMenuItem}
          role="button"
          tabIndex={0}
          onClick={onManageFilters}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onManageFilters();
            }
          }}
        >
          <FormattedMessage id="predict.manage_filters" defaultMessage="Manage filters" />
        </div>
        {activeCount > 0 && (
          <div
            className={styles.popoverMenuItem}
            role="button"
            tabIndex={0}
            onClick={onClearAll}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onClearAll();
              }
            }}
          >
            <FormattedMessage id="predict.clear_all_filters" defaultMessage="Clear all" />
          </div>
        )}
      </div>
    </PopoverContainer>
  );
};
